// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3vh2B","additionalInfo":"AgreementModal_additionalInfo__2dW6A"};